
import { alterarLocalRealizacao } from './alterar-local-realizacao.event';
import { pesquisaCep } from './pesquisa-cep.event';
import { naoAplicarGrupoSemelhante } from './nao-aplicar-grupo-semelhante.event';

export const events = {
    alterarLocalRealizacao,
    pesquisaCep,
    naoAplicarGrupoSemelhante

};